module.exports = __webpack_public_path__ + "img/buddy_leg.77fe56ad.svg";